module.exports = __webpack_public_path__ + "img/industrial-rental-logo.50cfd4f8.jpg";